import { DropdownSection } from '@leagueplatform/web-common-components';

export enum HIGHMARK_COMMON_ASSET_KEYS {
  HIGHMARK_PRIVACY_IMAGE = 'HIGHMARK_PRIVACY_IMAGE',
  HIGHMARK_EXIT_WARNING_IMAGE = 'HIGHMARK_EXIT_WARNING_IMAGE',
  SIGNOUT_ICON = 'SIGNOUT_ICON',
}

export enum TEST_CONFIG_FLAGS {
  forceAppWalkthrough = 'force_app_walkthrough',
  testSsoLink = 'test_sso_link',
  enableClaims = 'enable_claims',
}

export type HighmarkCommonAssets = Record<HIGHMARK_COMMON_ASSET_KEYS, unknown>;

export const throwImpersonationErrorType = {
  stack: {
    errors: [
      {
        code: 'forbidden',
      },
    ],
  },
};

export type NavigationAnalytics = {
  product_area: string;
  sub_product_area: string;
  screen_name: string;
  detail: string;
  content: {
    name: string;
  };
  node: {
    type: string;
  };
};

export type DropdownNavItemWithAnalytics = DropdownSection[number] & {
  analytics?: NavigationAnalytics;
};

export type UserDropdownSection = DropdownNavItemWithAnalytics[];
